class UserService {
    setUser(user) {
        this.user = user;
    }
}

export default new UserService();


// WEBPACK FOOTER //
// ./src/services/UserService.js